// prefix.js — Pfad-Präfix der neuen Oberfläche aus der Hülle (<html data-prefix>): '/next' in der Testphase, '' nach dem Umschalten.
// Fehlt das Attribut (alte Hüllen, Tests), gilt die Testphase.
export const P = (typeof document !== 'undefined' && document.documentElement.dataset.prefix != null)
  ? document.documentElement.dataset.prefix : '/next';
/** Pfad in der neuen Oberfläche: nx('/app') → '/next/app' bzw. '/app'. */
export const nx = (path) => P + path;
